import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';

import { colorFromMode } from '../../helpers';

/**
* -Polyline-
* Polyline component
**/
export default class Polyline extends React.Component {

	addPolyline = () => {

		let { map, google, path, rideName, onRoad, routeNo, color, opacity, dismount } = this.props;
		
		// Decode if encoded
		path = Array.isArray(path) ? path : google.maps.geometry.encoding.decodePath(path);

		// Options
		const options = {
			clickable: true,
			map,
			strokeColor: colorFromMode(this.props.color),
			strokeOpacity: opacity,
			strokeWeight: this.props.strokeWeight,
			zIndex: 1,
			path,
		};

		if (dismount) {
			options.icons = [{
				icon: {
					path: 'M 0,-1 0,1',
					scale: 2,
					strokeOpacity: 1,
				},
				offset: '0%',
				repeat: '10px',
			}];
		}

		this.polyline = new google.maps.Polyline(options);
		
		google.maps.event.addListener(this.polyline, 'click', () => {
			if (this.props.onClick) {
				this.props.onClick(rideName)
			};
		});

		// Show hover over.
		google.maps.event.addListener(this.polyline, 'mouseover', (e) => {

			let lat = e.latLng.lat();
			let lng = e.latLng.lng();

			// Prevent polyline coming in over the top on hover.
			if (this.props.onHover) {
				this.props.onHover(rideName, lat, lng, onRoad, routeNo, color);
			}

		});

	}

	componentDidMount() {
		this.addPolyline();
	}

	componentWillUnmount() {

		if (this.polyline) {
			this.polyline.setMap(null);
		}
	}

	render() {
		return null;
	}
}

Polyline.propTypes = {
	path: PropTypes.oneOfType([
		PropTypes.array,
		PropTypes.string
	]),
	color: PropTypes.string,
	onClick: PropTypes.func,
	opacity: PropTypes.number,
	onHover: PropTypes.func,
	rideName: PropTypes.string,
}

Polyline.defaultProps = {
	color: 'random',
}



// WEBPACK FOOTER //
// ./src/components/googlemaps/Polyline.js